/**
 * Build react-select options from active tags, then merge any already-assigned
 * tags (e.g. inactivated) so edit views keep them visible and selectable.
 */
export function mergeEventTagOptions(activeTags = [], assignedDetails = []) {
    const byId = new Map();

    for (const tag of activeTags) {
        if (!tag || tag._id == null) continue;
        byId.set(String(tag._id), { value: tag._id, label: tag.title || '' });
    }

    for (const tag of assignedDetails || []) {
        if (!tag || tag._id == null) continue;
        const id = String(tag._id);
        if (!byId.has(id)) {
            byId.set(id, { value: tag._id, label: tag.title || 'Unknown Tag' });
        }
    }

    return Array.from(byId.values());
}
